module.exports = __webpack_public_path__ + "static/expenseReport4-abec3b1b912a3d3fe853da455efddd4d.png";